import StandPageModel                 from '@/models/services/website/StandPageModel';
import StandPageValidationStatusModel from '@/models/services/website/StandPageValidationStatusModel';

// Statuts pour lesquels un standPage existant doit être MODIFIÉ plutôt que recréé.
export const EDITABLE_STATUS_REFERENCES: Website_StandPageValidationStatusReference[] = [
	'IN_CREATION',
	'VALIDATION_REQUESTED',
	'REFUSED',
];

// Résout la référence de statut d'un standPage à partir de la liste déjà chargée,
// sans déclencher de fetch de relation sur le modèle.
export const getStandPageStatusReference = (
	standPage: StandPageModel | null,
	validationStatuses: StandPageValidationStatusModel[],
): Website_StandPageValidationStatusReference | null => {
	if (!standPage) return null;
	const statusId = standPage.getId('standPageValidationStatus');
	return validationStatuses.find(s => s.id === statusId)?.reference ?? null;
};

// Applique la règle métier de sélection du standPage à éditer :
//  - s'il existe un standPage En création / À valider / Refusé, on l'édite.
//  - sinon, s'il n'y a qu'un standPage Validé, on repart de celui-ci pour créer une nouvelle version.
//  - les standPage Désactivés sont totalement ignorés.
// `standPages` doit être trié par id décroissant pour privilégier la version la plus récente.
export const selectStandPageToEdit = (
	standPages: StandPageModel[],
	validationStatuses: StandPageValidationStatusModel[],
): StandPageModel | null => {
	const refOf = (sp: StandPageModel) => getStandPageStatusReference(sp, validationStatuses);

	const usable = standPages.filter(sp => refOf(sp) !== 'DISABLED');

	const editable  = usable.find(sp => {
		const ref = refOf(sp);
		return ref !== null && EDITABLE_STATUS_REFERENCES.includes(ref);
	});
	const validated = usable.find(sp => refOf(sp) === 'VALIDATED');

	return editable ?? validated ?? null;
};
